module.exports = __webpack_public_path__ + "static/img/pexels-thisisengineering-3862615.07d251c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pexels-thisisengineering-3862615.png
// module id = tyi1
// module chunks = 0